import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectAuth } from "../components/auth/auth.selector";
import { selectGymData } from "../redux/reducers/gymDataSlice";
import { fetchGymData } from "../data/APIs";

export const useGymFilter = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const gymData = useSelector(selectGymData);

  const [gymValue, setGymValue] = useState(null);

  useEffect(() => {
    dispatch(fetchGymData(authData.user?.token));
  }, [dispatch, authData.user?.token]);

  const handleGymChange = useCallback((selectedValue) => {
    setGymValue(selectedValue);
  }, []);

  return {
    gymData,
    gymValue,
    handleGymChange,
    setGymValue,
  };
};
